/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Modal_Update_Vertical_LabelInputs */



/**
* | output |
* | --- |
* | "Update Vertical" |
*
* @param {Position_Modal_Update_Vertical_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_update_vertical_label = /** @type {((inputs?: Position_Modal_Update_Vertical_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Update_Vertical_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre a jour le vertical")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vertikales Update")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna verticale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить вертикаль")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar vertical")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("垂直更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("垂直方向の更新")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्टिकल अपडेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualização Vertical")
	return /** @type {LocalizedString} */ ("Update Vertical")
});